/**
 * TPM PUBLIC API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface SlotSelection { 
    startDate: string;
    appointmentResourceId: number;
}
export const SlotSelection_startDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SlotSelection_appointmentResourceId_Validators: ValidatorFn[] =
    [  Validators.required, ];


